/* API Examples for apiUrl.js */

/* export const apiUrl= "https://domain.example.com";
export const drName= "Dr. Click Demo"; */

/* export const apiUrl= "http://localhost:8000";
export const drName= "Dr. Click Demo"; */

/* export const apiUrl= "https://www.drakaroltalaveraapi.rocazit.com";
export const drName= "Dra. Karol Talavera"; */

export const apiUrl= "https://www.josainesanginezapi.rocazit.com";
export const drName= "Dra. Josaine Sanjines";

/* Before pushing to production make sure to build the project with the correct apiUrl  */